// decide which video player to use, and show videos for CDS/Home
import VideoJSView from '../../../adapters/VideoJs'
import { VideoSource } from '../../../adapters/VideoJs'

// re-export so no other modules have to depend directly on videoJs
export type { VideoSource } from '../../../adapters/VideoJs'

export const VideoView = (props: React.HTMLAttributes<HTMLDivElement> & { sources: VideoSource | VideoSource[] }) => {
  let { sources, ...divProps } = props
  return (
    <div style={{ minWidth: 100 }} {...divProps}>
      <p>hi video?</p>
      <VideoJSView options={{ sources: Array.isArray(sources) ? sources : [sources] }} />
      <p>bye video</p>
    </div>
  )
}
